import React, { useContext, useEffect, useState } from 'react'
import MenuBarComponent from '../../Components/MenuBarComponent';
import { InputText } from 'primereact/inputtext';
import { useSSR, useTranslation } from 'react-i18next';
import placePicture from '../../images/forest.jpg'
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';
import { PiInfo } from 'react-icons/pi';
import { Badge } from 'primereact/badge';
import { Controller, useForm } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from 'react-router-dom';
import { registerService } from '../../Service/UserService';
import { toast } from 'react-toastify';
import AuthContext from '../../Contexts/AuthContext';
import { listAllReligionsService } from '../../Service/ReligionService';
import { Dropdown } from 'primereact/dropdown';
import i18n from '../../multilingual/config';
import ReligionsDropdown from '../../Components/ReligionsDropdown';

function Register() {
    const { t } = useTranslation('register');
    const navigate = useNavigate()
    const {setUserAuth} = useContext(AuthContext)
    const [language, setLanguage] = useState(i18n.language)
    
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        control,
        formState: { errors },
      } = useForm();

    const sideClassStyle = `p-4 md:p-8 mx-4 md:mx-8 gap-4 md:gap-8
        flex justify-content-center flex-column-reverse md:flex-row`;

    const onSubmit = async (e) => {
        const {name, email, password, religion} = e
        const res = await registerService(name, email, password, religion)
        if (res?.user) {
            toast.success(t('register_success'))
            setUserAuth(res)
            navigate('/app/user_home_events')
        } else toast.error(t(res))
    }

    return (
        <div className='flex flex-column gap-4 background-accent-one'>
            <MenuBarComponent />
            <Tooltip target={'.is_public_message'} />
            <div className={sideClassStyle} style={{borderRadius: '0.5rem'}}>
                <div className='w-12 md:w-6 flex flex-column gap-2'>
                    <form onSubmit={handleSubmit(onSubmit)} className='flex flex-column gap-2'>
                        
                        <div className='flex flex-1 flex-column gap-1'>
                            <label>{t('name')}<span className='form-validation-message'>*</span></label>
                            <InputText className='w-full' {...register('name', {
                                required: t('name_validation_message'),
                            })} />
                            {errors.name && <span className='form-validation-message'>{errors.name.message}</span>}
                        </div>

                        <div className='flex flex-column gap-1'>
                            <label>{t('religion')}</label>
                            <Controller
                                name="religion" // Name of the field in the form
                                control={control}
                                render={({ field }) =>{ 
                                    return (
                                        <ReligionsDropdown field={field} errors={errors} />
                                )}}
                            />
                            {errors.religion && <span className='form-validation-message'>{errors.religion.message}</span>}
                        </div>

                        <div className='flex flex-1 flex-column gap-1'>
                            <label>{t('email')}<span className='form-validation-message'>*</span></label>
                            <InputText className='w-full' {...register('email', {
                                required: t('email_validation_message'),
                                pattern: {
                                    value: /^\S+@\S+\.\S+$/,
                                    message: t('email_invalid_message'),
                                },
                            })} />
                            {errors.email && <span className='form-validation-message'>{errors.email.message}</span>}
                        </div>

                        <div className='flex flex-column gap-1'>
                            <label>{t('password')}<span className='form-validation-message'>*</span></label>
                            <InputText type='password' className='w-full' {...register('password', {
                                required: t('password_validation_message')})} />
                            {errors.password && <span className='form-validation-message'>{errors.password.message}</span>}
                        </div>

                        <div className='flex flex-column gap-1'>
                            <label>{t('confirm_password')}<span className='form-validation-message'>*</span></label>
                            <InputText type='password' className='w-full' {...register('confirm_password', {
                                required: t('confirm_password_validation_message'),
                                validate: (value) =>
                                    value === getValues('password') || t('password_not_match'),})} />
                            {errors.confirm_password && <span className='form-validation-message'>{errors.confirm_password.message}</span>}
                        </div>


                        <div className='flex flex-column gap-2 align-items-center'>
                            <div className='flex gap-2 justify-content-center'>
                                <Button type='submit' label={t('save')} className='background-primary' />
                                <Button type='button' label={t('cancel')} className='background-secondary' onClick={()=>navigate('/register')} />
                            </div>
                            <Button type='button' label={t('login')} outlined className='text-color-primary w-max' onClick={()=>navigate('/login')} />
                        </div>
                    </form>
                </div>
                <div className='w-12 md:w-6 flex flex-column gap-2 md:gap-4'>
                    <div className='text-2xl md:text-4xl font-bold'>{t('register_title')}</div>
                    <div className='text-xl md:text-2xl'>{t('register_message')}</div>
                    <img src={placePicture} alt='place_picture' />
                </div>
            </div>
        </div>
)
}

export default Register